import { updateTheme } from '@cetelem/themes';
import { NamesThemes } from '@cetelem/themes/lib/model';
import '@design-system/base-button';
import '@design-system/base-card';
import '@design-system/base-checkbox';
import '@design-system/base-ds-guidelines';
import '@design-system/base-input';
import '@design-system/base-modal';
import '@design-system/base-radio-button';
import '@design-system/base-select';
import '@design-system/button-link';
import '@design-system/gender-input';
import '@design-system/numeric-stepper';
import '@design-system/pf-fraudnet';
import '@design-system/side-menu';
import React, { useContext } from 'react';
import { Route, Routes } from 'react-router-dom';
import { AppLayout, FormLayout } from './containers/Layout';
import { ResponseLayout } from './containers/Layout/ResponseLayout';
import Adresse from './pages/Adresse';
import Contact from './pages/Contact';
import Credits from './pages/Credits';
import Depenses from './pages/Depenses';
import ErrorPage from './pages/Error/ErrorPage';
import Identite from './pages/Identite';
import Logement from './pages/Logement';
import Naissance from './pages/Naissance';
import Nationalite from './pages/Nationalite';
import NouveauProject from './pages/NouveauProject';
import Recapitulatif from './pages/Recapitulatif';
import Response from './pages/Response/Response';
import Revenus from './pages/Revenus';
import SituationFamiliale from './pages/SituationFamiliale';
import SituationPro from './pages/SituationPro';
import { store } from './store/store';
import { Step, stepByName, stepByNameLocataire } from './utils/Steps';

export interface IAppConfig {
  msHostname: string;
  keyId: string;
  useMock: string;
  cetelemUrl: string;
  appEnv: string;
  conseillerUrl: string;
  cookiesUrl: string;
  mentionsLegalesUrl: string;
  rgpdUrl: string;
  exemple_immo_date_vigueur: string;
  exemple_immo_projet_montant: string;
  exemple_immo_projet_duree: string;
  exemple_immo_projet_tnc: string;
  exemple_immo_mensualites_total: string;
  exemple_immo_mensualites_2: string;
  exemple_immo_mensualites_suivantes: string;
  exemple_immo_mensualites_montant: string;
  exemple_immo_mensualites_taeg: string;
  exemple_immo_cout_total: string;
  exemple_immo_cout_interets: string;
  exemple_immo_frais_acte: string;
  exemple_immo_frais_compte: string;
  exemple_immo_frais_dossier: string;
  exemple_immo_montant_total: string;
  exemple_conso_projet_montant: string;
  exemple_conso_projet_duree: string;
  exemple_conso_projet_mensualite: string;
  exemple_conso_montant_total: string;
  exemple_conso_cout_interets: string;
  exemple_conso_frais_dossier: string;
  exemple_conso_mensualites_taeg: string;
  exemple_conso_mensualites_tnc: string;
  exemple_conso_date_vigueur: string;
  exemple_conso_cout_assurance: string;
  exemple_conso_taeg_assurance: string;
  exemple_conso_total_assurance: string;
  exemple_conso_duree_credit: string;
}

declare global {
  interface WindowWithEnv extends Window {
    _env_: IAppConfig;
  }
}

const App: React.FunctionComponent<Record<string, never>> = () => {
  updateTheme(NamesThemes.CETELEM);
  const {
    state: {},
  } = useContext(store);
  return (
    <Routes>
      <Route path={`${process.env.PUBLIC_URL}/`}>
        <Route index element={<AppLayout contentLayout={FormLayout} content={<Logement />} step={Step.LOGEMENT} />} />
        <Route
          path={stepByName(Step.LOGEMENT)?.path}
          element={<AppLayout contentLayout={FormLayout} content={<Logement />} step={Step.LOGEMENT} />}
        />
        <Route
          path={stepByName(Step.CREDITS)?.path}
          element={<AppLayout contentLayout={FormLayout} content={<Credits />} step={Step.CREDITS} />}
        />
        <Route
          path={stepByName(Step.NOUVEAUPROJECT)?.path}
          element={<AppLayout contentLayout={FormLayout} content={<NouveauProject />} step={Step.NOUVEAUPROJECT} />}
        />
        <Route
          path={stepByName(Step.IDENTITE)?.path}
          element={<AppLayout contentLayout={FormLayout} content={<Identite />} step={Step.IDENTITE} />}
        />
        <Route
          path={stepByName(Step.NATIONALITE)?.path}
          element={<AppLayout contentLayout={FormLayout} content={<Nationalite />} step={Step.NATIONALITE} />}
        />
        <Route
          path={stepByName(Step.NAISSANCE)?.path}
          element={<AppLayout contentLayout={FormLayout} content={<Naissance />} step={Step.NAISSANCE} />}
        />
        <Route
          path={stepByName(Step.SITUATIONFAMILIALE)?.path}
          element={
            <AppLayout contentLayout={FormLayout} content={<SituationFamiliale />} step={Step.SITUATIONFAMILIALE} />
          }
        />
        <Route
          path={stepByName(Step.SITUATIONPRO)?.path}
          element={<AppLayout contentLayout={FormLayout} content={<SituationPro />} step={Step.SITUATIONPRO} />}
        />
        <Route
          path={stepByName(Step.REVENUS)?.path}
          element={<AppLayout contentLayout={FormLayout} content={<Revenus />} step={Step.REVENUS} />}
        />
        <Route
          path={stepByNameLocataire(Step.DEPENSES)?.path}
          element={<AppLayout contentLayout={FormLayout} content={<Depenses />} step={Step.DEPENSES} />}
        />
        <Route
          path={stepByName(Step.CONTACT)?.path}
          element={<AppLayout contentLayout={FormLayout} content={<Contact />} step={Step.CONTACT} />}
        />
        <Route
          path={stepByName(Step.ADRESSE)?.path}
          element={<AppLayout contentLayout={FormLayout} content={<Adresse />} step={Step.ADRESSE} />}
        />
        <Route
          path={stepByName(Step.RECAPITULATIF)?.path}
          element={<AppLayout contentLayout={FormLayout} content={<Recapitulatif />} step={Step.RECAPITULATIF} />}
        />
        <Route
          path={stepByName(Step.RESPONSE)?.path}
          element={<AppLayout contentLayout={ResponseLayout} content={<Response />} step={Step.RESPONSE} />}
        />
        <Route path="oups" element={<ErrorPage />} />
      </Route>
    </Routes>
  );
};

export default App;
